import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SharedTransactions from "../Shared/SharedTransactions";
import { useTranslation } from "react-i18next";
import { getAssetImgSrc } from "helpers/assetImgSrc";
import { fetchGoldWithdrawals } from "store/actions";

export default function Withdrawals() {
  const { t } = useTranslation();
  const { withdrawals = [], loading } = useSelector((state) => state.goldReducer.withdrawals);
  const { subPortal } = useSelector((state) => state.Layout);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGoldWithdrawals({
      isDemo: subPortal === "DEMO",
    }));
  }, []);
  const columns = [
    {
      dataField: "",
      text: "",
    },
    {
      text: t("Asset"),
      dataField: "walletId",
      formatter: (item) => (
        <div className="balances__company">
          <div className="balances__logo">
            <img src={getAssetImgSrc(item.walletId?.assetId)} alt="" />
          </div>
          <div className="balances__text">
            {item?.walletId?.asset ? item.walletId.asset : ""}
          </div>
        </div>
      ),
    },
    {
      text: t("Type"),
      dataField: "type",
    },
    {
      text: t("Date"),
      dataField: "createdAt",
      formatter: (item) => {
        let d = new Date(item.createdAt);
        d = `${d.toLocaleDateString()}, ${d.toLocaleTimeString()}`;
        return d;
      },
    },
    {
      text: t("Amount"),
      dataField: "amount",
      formatter: (item) =>
        item.amount && item.amount["$numberDecimal"]
          ? parseFloat(item.amount["$numberDecimal"])?.toFixed(2)
          : parseFloat(item.amount)?.toFixed(2),
    },
    {
      text: t("Status"),
      dataField: "status",
    },
  ];
  return (
    <SharedTransactions data={withdrawals} loading={loading} t={t} columns={columns} />
  );
}
